import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, FormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { concatMap, filter, map, shareReplay } from 'rxjs/operators';
import { ItineraryStepDocumentConfigDistribution } from 'src/app/developer/models/itinerary-step-document-config-distribution';
import { ItineraryStepDocumentConfigEntity } from 'src/app/developer/models/itinerary-step-document-config-entity';
import { Distribution } from '../models';
import { DistributionItineraryConfig } from '../models/distribution-itinerary-config';
import { DistributionService } from '../services';

import { DataFieldGroupContainerComponent } from '../../shared/datafields/datafield-group-container.component';

@Component({
    selector: 'app-distribution-itinerary-step',
    templateUrl: './distribution-itinerary-step.component.html',
    styleUrls: ['./distribution-itinerary-step.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, DataFieldGroupContainerComponent]
})
export class DistributionItineraryStepComponent implements OnInit, OnChanges {

    @Input() config: DistributionItineraryConfig;
    @Input() formGroup: UntypedFormGroup = new UntypedFormGroup({});

    showConfiguration = false;

    constructor(
        private distributionService: DistributionService) {
    }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    get isValid() {
        return this.formGroup.valid;
    }
}
